import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useParams } from 'react-router-dom';
import type { Event as EventType } from '../types';
import useApi from '../hooks/api';
import { useAppDispatch } from '../hooks/store';
import { eventSet } from '../store/eventSlice';

type EventAnswer = {
	event: EventType
};

const Event = () => {
	const { t, i18n } = useTranslation();
	const lang = i18n.language === 'en' ? 'en' : 'ru';
	const dispatch = useAppDispatch();
    const { slug } = useParams();
	const [ data, error, isLoading ] = useApi('get', '/events/' + slug);

	useEffect(() => {
		if(!data) return;
		const event = (data as EventAnswer).event;
		dispatch(eventSet(event));
		// Если в мероприятии установлены собственные строки
		// для локализации, загружаем их в систему.
		if(!event.intl) return;
		try {
			const intl = JSON.parse(event.intl);
			if(intl.ru) i18n.addResources('ru', 'translation', intl.ru);
			if(intl.en) i18n.addResources('en', 'translation', intl.en);
		} catch (error) {
			console.error('Can not override internationalization');
			console.error(error);
		}
	}, [ data, i18n, dispatch ]);

	if(data) return <Outlet/>;

	return (
		<div className='Page'>
			<h1>{slug}</h1>
			{isLoading && <p>{t('common.loading')}</p>}
			{error && <p className='error'>{error.text[lang]}</p>}
		</div>
	);
};

export default Event;
